// What the cart pill needs to render, from whichever checkout is asking.
//
// V2's cart lives in TanStack Query and V1's in Vuex, so the V2 callers pass their values in and
// V1 falls through to the getters. Shared because three surfaces show this pill now - the nav, and
// both versions of the categories bar that replaces the nav on scroll - and a fourth copy of the
// same three fall-throughs is how the two checkouts drift apart.
export function cartPillSummary(store, { quantity = null, total = null, showPrices = null } = {}) {
  return {
    quantity: quantity != null ? quantity : store?.getters?.cartSize || 0,
    total: total != null ? total : store?.getters?.currentCart?.attributes?.total_price?.format || null,
    showPrice: showPrices != null ? showPrices : store?.getters?.currentBottle?.attributes?.show_prices !== false
  }
}
